<script>
import Http from 'axios';
import GoogleMapStyles from '#app#/global/googleMapStyles.js';
import loadGoogleMapsApi from 'load-google-maps-api';

export default {
    props: ['content'],

    data() {
        return {
            loading: false,
            locations: {
                initial: [],
                filtered: [],
                active: null,
            },
            searchInput: null,
            searchResult: null,
            map: null,
            googleMaps: null,
            maxRadius: 50000,
        }
    },

    async mounted() {
        await this.fetchData();
        await this.initApi();

        if(this.$refs.map) {
            this.initMap();
        }
    },

    methods: {
        async initApi() {
            return loadGoogleMapsApi({
                key: window.GMAPS_API_KEY,
                libraries: ['geometry']
            }).then((googleMaps) => {
                this.googleMaps = googleMaps;
            });
        },

        initMap() {
            this.map = new this.googleMaps.Map(this.$refs.map, {
                disableDefaultUI: true,
                styles: GoogleMapStyles,
            });

            this.setupMarkers(this.locations.initial);
        },

        async fetchData() {
            this.loading = true;
            return Http.get('/api/locator/location').then(res => {
                this.locations.initial = res.data;
                this.loading = false;
            });
        },

        search() {
            const geocoder = new this.googleMaps.Geocoder();
            this.loading = true;

            geocoder.geocode({
                address: this.searchInput,
                componentRestrictions: { country: 'ch' }
            }, (result, status) => {
                if (status === 'OK' && result.length > 0) {
                    const bestResult = result[0];
                    this.showResults(bestResult);
                } else {
                    this.locations.filtered = [];
                    this.setMapBounds(this.locations.initial);
                }

                this.loading = false;
            });

            if(typeof fbq !== 'undefined') {
                fbTracking.sendEvent('Location Search');
            }

            if(typeof sendTrackingEvent !== 'undefined') {
                sendTrackingEvent.sendEvent('Location', 'Search', this.searchInput);
            }
        },

        showResults(geocodedResult) {
            this.searchResult = geocodedResult;
            this.searchInput = geocodedResult.formatted_address;

            this.locations.initial = this.locations.initial.map(location => {
                location.distanceToResult = Math.round(this.googleMaps.geometry.spherical.computeDistanceBetween(
                    this.searchResult.geometry.location,
                    new this.googleMaps.LatLng(location.lat, location.lng)
                ));

                return location;
            });

            this.locations.filtered = this.locations.initial.filter(location => location.distanceToResult <= this.maxRadius);
            if (this.locations.filtered.length > 0) {
                this.locations.filtered.sort((a, b) => a.distanceToResult - b.distanceToResult);
                this.locations.filtered = this.locations.filtered.slice(0, 5);
                this.setMapBounds(this.locations.filtered);
            }
        },

        setupMarkers(locations) {
            locations.forEach(location => {
                const marker = new this.googleMaps.Marker({
                    map: this.map,
                    position: {
                        lat: location.lat,
                        lng: location.lng
                    },
                    icon: new this.googleMaps.MarkerImage(
                        '/images/icons/map-marker-alt-light.svg',
                        new this.googleMaps.Size(40, 40),
                        new this.googleMaps.Point(0, 0),
                        new this.googleMaps.Point(20, 40),
                        new this.googleMaps.Size(40, 40),
                    )
                });

                const infoWindow = new this.googleMaps.InfoWindow({
                    content: `
                        <strong>${location.name}</strong><br>
                        ${location.street} ${location.street_no || ''}<br>
                        ${location.zip} ${location.city}<br>
                        ${location.country || ''}
                    `
                });

                marker.addListener('click', e => {
                    infoWindow.open(this.map, marker);
                    this.setActiveLocation(location);
                })
            });

            this.setMapBounds(locations);
        },

        setMapBounds(locations) {
            if(this.map) {
                if(locations.length > 1){
                    let bounds = new this.googleMaps.LatLngBounds();
                    locations.forEach(location => bounds.extend({ lat: location.lat, lng: location.lng }));
                    this.map.fitBounds(bounds);
                } else {
                    this.map.setCenter({ lat: locations[0].lat, lng: locations[0].lng });
                    this.map.setZoom(15);
                }
            }
        },

        setActiveLocation(location) {
            if (this.locations.active == location) {
                location = null;
            }

            this.locations.active = location;

            if(this.map) {
                if (location) {
                    this.map.panTo({ lat: location.lat, lng: location.lng });
                    this.map.setZoom(15);
                } else {
                    this.setMapBounds(this.locations.filtered);
                }
            }
        },

        buildGoogleMapsLink(location) {
            return `https://maps.google.com?q=${location.street} ${location.street_no || ''}, ${location.zip} ${location.city}, ${location.country || ''}`;
        },

        sendTrackingEvent(category, action, label = '') {
            gaTracking.sendEvent(category, action, label);
        }
    }
}
</script>



// WEBPACK FOOTER //
// js/components/package/RF/Locator/BaseLocator.vue